import { useMediaQuery, useTheme } from '@mui/material';
import { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import OptionsButtonCustom from '../../../../components/option-button/OptionsButtonCustom';
import TableRowCommon from '../../../../components/table/TableRowCommon';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import { PollTypeApi } from '../../../../api/poll-type/poll-type.api';
import { RootState } from '../../../../store/store';
import { checkPermission } from '../../../../utils/app.utils';
import { dateTimeToView } from '../../../../utils/date.utils';

const ManageState = () => {
    const { t } = useTranslation();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.up("md"));
    const dispatch = useDispatch();

    const profileReducer = useSelector((state: RootState) => state.profile.profile);
    const permission: any[] = profileReducer?.permission || [];
    const checkPermit = checkPermission('WEBSITE_STRUCTURE_POLL_CATEGORY_TYPE', permission);

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(10);
    const [totalItems, setTotalItems] = useState<number>(0);
    const [sortBy, setSortBy] = useState<string>("modified_date");
    const [sortType, setSortType] = useState<string>("DESC")
    const [keyword, setKeyword] = useState<string>("");
    const [id_poll_type, set_id_poll_type] = useState<number | null>(null);
    const [status, set_status] = useState<string>("");

    const [showModal, setShowModal] = useState<string>("");

    const [data, setData] = useState<any[]>([]);
    const [startDate, setStartDate] = useState<string>("");
    const [endDate, setEndDate] = useState<string>("");
    const [date_range, set_date_range] = useState<string[]>([]);
    const [form, set_form] = useState<{ poll_type: string }>({
        poll_type: ""
    })


    const handleCloseModal = () => {
        setShowModal("");
        set_id_poll_type(null);
        set_form({ poll_type: "" })
    }
    const handleChangeDateRange = (date_value: string[]) => {
        set_date_range(date_value);
        setStartDate(date_value[0]);
        setEndDate(date_value[1]);
    }
    const handleClearDateRange = () => {
        set_date_range([]);
        setStartDate("");
        setEndDate("");
    }
    const handleRequestSort = (sortBy: string, sortType: string) => {
        setSortBy(sortBy)
        setSortType(sortType)
    }

    const headCells = [
        {
            id: "id_poll_type", width: 50, sortable: false, disablePadding: false, align: 'center', label: t("ลำดับ")
        },
        {
            id: "subject_name", disablePadding: false, width: 140, align: "left", label: t("ชื่อหมวดหมู่โพลโหวต")
        },

        {
            id: "detail", disablePadding: false, align: "center", width: 140, label: t("ผู้สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "status", disablePadding: false, align: "center", width: 141, label: t("วันที่สร้าง/แก้ไขล่าสุด")
        },
        {
            id: "action", disablePadding: false, align: "left", padding: "0 8px", width: 80, class: matches && data.length > 0, label: ""
        },
    ];
    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const {
            poll_type,
            created_by,
            created_date,
            modified_date,
            modified_by,
            id_poll_type

        } =
            objData;
        const objRenderData = {
            key: no,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: no || "-" },
                {
                    option: "TEXT",
                    align: "left",
                    label: poll_type || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_by || created_by || "-",
                },
                {
                    option: "TEXT",
                    align: "center",
                    label: modified_date ? dateTimeToView(modified_date) : created_date ? dateTimeToView(created_date) : "-"
                },
                {
                    option: "COMPONENT",
                    align: "center",
                    class: matches && data.length > 0,
                    component: <div className='flex justify-center items-center'>
                        <OptionsButtonCustom
                            enableEdit={checkPermit.isUpdate}
                            enableView={checkPermit.isView}
                            enableDelete={checkPermit.isDelete}
                            onViewClick={() => {
                                setShowModal('VIEW');
                                set_form(objData)
                                set_id_poll_type(id_poll_type)
                            }}
                            onEditClick={() => {
                                setShowModal('EDIT');
                                set_form(objData)
                                set_id_poll_type(id_poll_type)

                            }}
                            onDeleteClick={() => handleDeleteList(id_poll_type)}
                        />
                    </div>
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    const handleDeleteList = (id_poll_type: number) => {
        alertActive(t("ลบหมวดหมู่โพลโหวต"), t("ต้องการลบหมวดหมู่โพลโหวต ? "), undefined, undefined, async () => {
            dispatch(setLoading());
            await PollTypeApi.deletePollType(id_poll_type).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("ลบหมวดหมู่โพลโหวต"), t("ลบหมวดหมู่โพลโหวต เรียบร้อยแล้ว"))
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("ลบหมวดหมู่โพลโหวต"), t("ลบหมวดหมู่โพลโหวต ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }
    const handleGetData = useCallback(async () => {
        let query: any = {
            page: page,
            limit: pageLimit
        }
        if (keyword) query = { ...query, search: keyword }
        if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
        if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
        dispatch(setLoading());
        await PollTypeApi.getPollTypeList(query).then((res) => {
            if (res.status < 300) {
                setData(res.data?.data?.items || []);
                setTotalItems(res.data?.data?.meta?.totalItems || 0)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }, [page, pageLimit, status, keyword, startDate, endDate])


    // const handleDownloadReport = async () => {
    //     let query: complaintReport = {}
    //     if (search) query = { ...query, keyword: search }
    //     dispatch(setLoading());
    //     await ReportApi.complaintTypeReport(query).then((res) => {
    //         if (res.status < 300) {
    //             const data = res.data;
    //             const blob_file = new Blob([data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    //             saveAs(blob_file, t("COMPLAINTS_MANAGE_CATEGORY"))
    //         }
    //     }).catch((err) => {
    //         console.log(err)
    //         alertError(t("COMPLAINTS_DOWNLOAD_FILE"), t("COMPLAINTS_DOWNLOAD_FAILED"))
    //     }).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }
    // const handleGetOneDetail = async (id_complaints_type: number, mode: string) => {
    //     setShowModal(mode);
    //     set_id_complaints_type(id_complaints_type)
    //     dispatch(setLoading());
    //     await ComplaintTypeApi.(id_complaints_type).then((res) => {
    //         if (res.status < 300) {
    //             set_complaints_type_form((prev) => ({ ...prev, complaints_type_name: res.data?.data?.complaints_type_name }))
    //         }
    //     }).catch((err) => console.log(err)).finally(() => {
    //         dispatch(unsetLoading());
    //     })
    // }

    const handleSubmitForm = async () => {
        dispatch(setLoading());
        if (id_poll_type) {
            await PollTypeApi.updatePollType(id_poll_type, { poll_type: form.poll_type }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("แก้ไขหมวดหมู่โพลโหวต"), t('แก้ไขหมวดหมู่โพลโหวต เรียบร้อยแล้ว'))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("แก้ไขหมวดหมู่โพลโหวต"), t("แก้ไขหมวดหมู่โพลโหวต ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        } else {
            await PollTypeApi.createPollType({ poll_type: form.poll_type }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("สร้างหมวดหมู่โพลโหวต"), t("สร้างหมวดหมู่โพลโหวต เรียบร้อยแล้ว"))
                    handleCloseModal();
                    handleGetData();
                }
            }).catch((err) => {
                console.log(err)
                alertError(t("สร้างหมวดหมู่โพลโหวต"), t("สร้างหมวดหมู่โพลโหวต ไม่สำเร็จ"))
            }).finally(() => {
                dispatch(unsetLoading());
            })
        }
    }

    useEffect(() => {
        handleGetData();
    }, [handleGetData])


    return {
        page,
        pageLimit,
        setPage,
        setPageLimit,
        sortBy,
        sortType,
        handleRequestSort,
        headCells,
        renderData,
        data,
        totalItems,
        id_poll_type,
        set_id_poll_type,
        // handleDownloadReport,
        showModal,
        handleCloseModal,
        form,
        set_form,
        handleSubmitForm,
        setShowModal,
        setKeyword,
        handleChangeDateRange,
        date_range,
        handleClearDateRange,
        checkPermit
    }
}

export default ManageState
